import PortalIdParser from 'PortalIdParser';
import AuthedApp from './AuthedApp';
import { APP } from './constants/AuthType';
const appAuthConfig = {
  authType: APP,
  rootUrl: `/pricing/${PortalIdParser.get()}`,
  // should match deploy yaml
  defaultHubRoute: '/marketing'
};
new AuthedApp(appAuthConfig).start().catch(() => {});